import { User } from '@buyiq-core/models/user';

export class FeedbackData {
    page?: string;
    user?: User;

    constructor(options?: Partial<FeedbackData>) {
        Object.assign(this, options);
    }
}

export class Feedback {
    userId: number;
    storeId: number;
    content: string;
    application: string;

    constructor(options?: Partial<Feedback>) {
        Object.assign(this, options);
    }
}

export class FeedbackFormObject {
    firstName: string;
    lastName: string;
    email: string;
    feedback: string;

    constructor(options?: Partial<FeedbackFormObject>) {
        Object.assign(this, options);
    }
}
